module.exports = __webpack_public_path__ + "static/media/cUSDC-logo.65cd27a9.png";